import { white, blue } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import {
	gridGutterHalf,
    fontSize12,
    gridGutter1q1dot5
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { offersVenderMilhasDiamondColor } from '../../../../shared/variables';

export const defaultStyle = `
    align-self: flex-end;
    padding-left: ${gridGutter1q1dot5}px;
    @media (max-width: 767px) {
        align-self: baseline;
        padding-left: 0;
        padding-top: ${gridGutterHalf}px;
    }

    div {
        color: ${white};
        font-weight: 600;
        font-size: ${fontSize12};
        padding: 4px 10px;
        border-radius: 4px;
        margin-bottom: 4px;
        @media (max-width: 767px) {
            margin-bottom: ${gridGutter1q1dot5}px;
        }

        &.blue {
            background-color: ${blue};
        }

        &.dark {
            background-color: ${offersVenderMilhasDiamondColor};
        }

        &.orange {
            background-color: #d97d00;
        }
    }
`;
